import { useQuery } from '@tanstack/react-query';
import { getTransferHistory } from '@/services/credit-worker.service';
import { PARTNER_ID } from '@/constants';

export function useTransferHistory() {
  const query = useQuery({
    queryKey: ['funding', 'transfer-history', PARTNER_ID],
    queryFn: () => getTransferHistory(PARTNER_ID),
  });

  return {
    transfers: query.data?.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
